import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ComponentModule } from './shared/component/component.module';
import { JsonDateInterceptor } from './global/interceptor/JsonDateInterceptor';
import { JwtInterceptor } from './global/interceptor/JwtInterceptor';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { FirebaseService } from './global/services/firebase.service';
import { HelperFunctions } from './utils/helper.functions';
import { environment } from '../environments/environment';
import { MobileForwardComponent } from './shared/component/mobile-forward/mobile-forward.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsFunctions } from './utils/reactiveForms.functions';
import { AddressFunctions } from './utils/address.functions';
import { StopFunctions } from './utils/stop.functions';
import { StockKeepingUnitFunctions } from './utils/stockKeepingUnit.functions';
import { HaulierRatingFunctions } from './utils/haulierRating.functions';
import { FeatureFlagServiceV2 } from './global/services/feature-flag-v2/feature-flag.service';
import { CheckShipperPermissionPipe } from './shared/component/directives/check-shipper-permission.pipe';

@NgModule({
  declarations: [AppComponent, MobileForwardComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    AngularFireAuthModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JsonDateInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (featureFlagService: FeatureFlagServiceV2) => {
        return () => featureFlagService.init();
      },
      deps: [FeatureFlagServiceV2],
      multi: true,
    },
    HelperFunctions,
    Title,
    FirebaseService,
    NgbActiveModal,
    ReactiveFormsFunctions,
    AddressFunctions,
    StopFunctions,
    StockKeepingUnitFunctions,
    HaulierRatingFunctions,
    CheckShipperPermissionPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
